import capitalizeFirstLetter from "./capitalizeFirstLetter";

function snippetFix(snippet: string) {
  if (!snippet) return "";

  // eslint-disable-next-line sonarjs/slow-regex
  const regex = /\([^)]+$/;
  if (regex.test(snippet)) {
    return snippet + ")";
  }

  return capitalizeFirstLetter(snippet);
}

export default snippetFix;
